import React from "react";
import { CvpButton } from "../../../Components/Buttons/CvpButton";

import styled from "styled-components";
import { device } from "../../../WSUtils/constants/mediaQueries";
import { ButtonProps } from "primereact/button";

const MessageButtons: React.FC<ButtonProps> = ({}) => {
  return (
    <StyledMessageButtons className="cvp-mesage-btn-container">
      <StyledBtn
        className="cvp-message-btn"
        label="Svar"
        icon="pi pi-pencil"
        iconPos="left"
      />
      <StyledBtn
        className="cvp-message-btn cvp-close-btn "
        label="Lukk"
        icon="pi pi-times"
        iconPos="left"
      />
    </StyledMessageButtons>
  );
};

export default MessageButtons;

export const StyledMessageButtons = styled.div`
  &.cvp-mesage-btn-container {
    display: flex;
    column-gap: 1rem;
    margin-bottom: 2rem;

    .cvp-close-btn {
      background-color: var(--surface-600);
      border-color: var(--surface-600);

      &:hover {
        background-color: var(--surface-700);
        border-color: var(--surface-700);
        -webkit-transition: all ease-out 0.3s;
        -moz-transition: all ease-out 0.3s;
        -o-transition: all ease-out 0.3s;
        transition: all ease-out 0.3s;
      }

      &:focus {
        box-shadow: 0 0 0 0.2rem var(--surface-500);
      }
    }

    @media ${device} {
    }
  }
`;

export const StyledBtn = styled(CvpButton)`
  &.cvp-message-btn {
    padding: 0.6rem 1.1rem;
  }
`;
